const initialState = {
    sections: [],
    loading: false,
    error: null,
};

const localIntelligenceReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'business/get-local-intelligence/pending':
            return { ...state, loading: true, error: null };
        case 'business/get-local-intelligence/fulfilled':
            return { ...state, loading: false, sections: action.payload.data };
        case 'business/get-local-intelligence/rejected':
            return { ...state, loading: false, error: "No local intelligence data found." };
        default:
            return state;
    }
};

export default localIntelligenceReducer;
